import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cancel-flow__screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "cancel-flow__eyebrow" }, "BEFORE YOU GO...", -1)
const _hoisted_3 = { class: "cancel-flow__main" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "cancel-flow__heading" }, "Feedback", -1)
const _hoisted_5 = { style: {"width":"100%"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "cancel-flow__body",
  style: {"margin-bottom":"16px"}
}, "Please tell us why you are leaving so we can make Ditto better. Future Ditto users will thank you.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  class: "cancel-flow__body",
  style: {"margin-bottom":"24px","font-weight":"600"}
}, "Select all that apply (required):", -1)
const _hoisted_8 = {
  class: "cancel-flow__feedback-list",
  role: "group",
  "aria-label": "Cancellation reasons"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "20 6 9 17 4 12" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "cancel-flow__feedback-label" }
const _hoisted_13 = ["aria-invalid", "value"]
const _hoisted_14 = {
  key: 0,
  class: "cancel-flow__body",
  role: "alert",
  style: {"color":"#cc2a2a","margin-top":"16px"}
}
const _hoisted_15 = { class: "cancel-flow__buttons" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasons, (r) => {
            return (_openBlock(), _createElementBlock("label", {
              key: r.id,
              class: "cancel-flow__feedback-row",
              onClick: _withModifiers(($event: any) => (_ctx.$emit('toggle-reason', r.id)), ["prevent"])
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["cancel-flow__checkbox", { 'is-checked': _ctx.selectedReasons.indexOf(r.id) >= 0 }])
              }, _hoisted_11, 2),
              _createElementVNode("span", _hoisted_12, _toDisplayString(r.label), 1)
            ], 8, _hoisted_9))
          }), 128))
        ]),
        (_ctx.selectedReasons.indexOf('other') >= 0)
          ? (_openBlock(), _createElementBlock("textarea", {
              key: 0,
              class: "cancel-flow__other-input",
              placeholder: "Provide a brief explanation",
              rows: "2",
              "aria-invalid": _ctx.otherTextMissing,
              value: _ctx.otherText,
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:other-text', ($event.target as HTMLTextAreaElement).value)))
            }, null, 40, _hoisted_13))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        type: "button",
        class: "cancel-flow__btn cancel-flow__btn--primary",
        disabled: _ctx.finalizing,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('stay')))
      }, "I'll stay", 8, _hoisted_16),
      _createElementVNode("button", {
        type: "button",
        class: "cancel-flow__btn cancel-flow__btn--danger",
        disabled: _ctx.finalizing,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('next')))
      }, _toDisplayString(_ctx.finalizing ? 'Cancelling…' : 'Continue cancellation'), 9, _hoisted_17)
    ])
  ]))
}